import { ApiRequestService } from 'src/app/core/services/api-request.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retryWhen, delay, take, tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionExpiredComponent } from 'src/app/shared/components/sessionExpired/sessionExpired/session-expired.component';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
    providedIn: 'root'
})
export class ServerErrorsInterceptor implements HttpInterceptor {
    constructor(private router: Router, private apiRequestService: ApiRequestService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retryWhen((error: any) => {
                let retries;
                if (request.url.includes('/bea/attachment')) {
                    retries = 0;
                } else if (request.url.includes('/tuwaiq') || request.method === 'PUT' || request.url.includes('/login') || request.method === 'PATCH') {
                    return error.pipe(
                        tap((errorStatus: any) => {
                            throw errorStatus;
                        })
                    );
                } else {
                    retries = 1;
                }
                let count = 0;
                return error.pipe(
                    delay(500),
                    take(retries),
                    tap((errorStatus: any) => {})
                );
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 403) {
                    //  this.router.navigate(['NotAthorizedPageComponent'])
                } else if (err.status === 401) {
                    this.apiRequestService.handleSessionExpired();
                }

                const errors = err.statusText;
                return throwError(err);
            })
        );
    }
}
